var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellStatusWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6.25,
    stroke: "#F59D24",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 12C9.82693 12 9.65776 12.044 9.51387 12.1264C9.36998 12.2088 9.25783 12.3259 9.1916 12.463C9.12538 12.6 9.10805 12.7508 9.14181 12.8963C9.17557 13.0418 9.25891 13.1754 9.38128 13.2803C9.50364 13.3852 9.65955 13.4566 9.82928 13.4856C9.99901 13.5145 10.1749 13.4997 10.3348 13.4429C10.4947 13.3861 10.6314 13.29 10.7275 13.1667C10.8236 13.0433 10.875 12.8983 10.875 12.75C10.875 12.5511 10.7828 12.3603 10.6187 12.2197C10.4546 12.079 10.232 12 9.99998 12Z",
    fill: "#F59D24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.3096V7",
    stroke: "#F59D24",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellStatusWarning);
export default __webpack_public_path__ + "static/media/icn_table_cell_Status_Warning.8894e1cd875f923ae6d14ac58ed60ea1.svg";
export { ForwardRef as ReactComponent };